//
import { UserSellerModel } from '@/models'
import {
    generateFetchDataFunction,
    generateDeleteItemFunction,
} from '../DataTableService'

import create from './create'
import fetchById from './fetchById'
import populate from './populate'
import remove from './remove'
import update from './update'

//
const dtFetchData = generateFetchDataFunction(
        UserSellerModel,
        ['hr_employee.g_branch_office'],
        ['customers', 'is_ground_seller', 'commissions'],
        populate
    ),
    dtDeleteItem = generateDeleteItemFunction(UserSellerModel)

//
export default {
    create,
    dtFetchData,
    dtDeleteItem,
    fetchById,
    remove,
    update,
}
